import { render, staticRenderFns } from "./MapPolygon.vue?vue&type=template&id=1da6179d&scoped=true&"
import script from "./MapPolygon.vue?vue&type=script&lang=js&"
export * from "./MapPolygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da6179d",
  null
  
)

export default component.exports